module.exports = __webpack_public_path__ + "img/bg_sweet_shop.3f2f5453.jpg";